import { useState, useEffect } from 'react'
import { api } from 'core/api/ConnectionManager'
import { getThemeStyleValue } from 'theme/colors'
import { defaultThemeStyles } from 'blocks.app/app/app.theme.jcss'
import { defaultThemeStyles as defaultThemeDashboardStyles } from 'organisms/Dashboard/Dashboard-theme'
import { colors } from '../../../theme'
import { palette } from 'theme/tokens/palette'
import {
    IDashboardScoreboardDevicesData,
    IScoreboardStat,
    ScoreboardStatsResponse,
    ScoreboardStatusKey,
} from './dashboard__scoreboardDevices.types'

let componentIsMounted: boolean = false
const getColorForDevicesNumber = (key: ScoreboardStatusKey) => {
    switch (key) {
        case 'online':
            return `var(--var-module-dashboard-component-dashboard-style-scoreboard-online, ${colors.blue})`
        case 'error':
            return `var(--var-module-dashboard-component-dashboard-style-error, ${defaultThemeDashboardStyles.error})`
        case 'offline':
            return `var(--var-module-dashboard-component-dashboard-style-offline, ${defaultThemeDashboardStyles.offline})`
        case 'updating':
        case 'notSynchronized':
            return palette.neutral[400]
        default:
            return getThemeStyleValue('app', 'app', 'textMain') || defaultThemeStyles.textMain
    }
}

const initialState: IDashboardScoreboardDevicesData = {
    stats: null,
    devicesCount: 0,
}

function DashboardScoreboardDevicesMethods() {
    const [data, setData] = useState<IDashboardScoreboardDevicesData>(initialState)

    useEffect(() => {
        componentIsMounted = true
        getDigitalSignageStats()

        return () => {
            componentIsMounted = false
        }
    }, [])

    function getDigitalSignageStats() {
        api.send<object, ScoreboardStatsResponse>('getScoreboardsStats', {}, { showEmitError: false }).then((res) => {
            if (!componentIsMounted) {
                return
            }

            const stats: IScoreboardStat[] = []
            let devicesCount = 0

            for (const key of Object.keys(res) as ScoreboardStatusKey[]) {
                const value = res[key]

                stats.push({
                    label: key,
                    color: getColorForDevicesNumber(key),
                    key,
                    value,
                })

                devicesCount += value
            }

            setData({ stats, devicesCount })
        })
    }

    return {
        s_: {
            data,
        },
    }
}

export default DashboardScoreboardDevicesMethods
